import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgStopFilled = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M8.304 7.005a1.3 1.3 0 0 0-1.3 1.3v7.4a1.3 1.3 0 0 0 1.3 1.3h7.392a1.3 1.3 0 0 0 1.3-1.3v-7.4a1.3 1.3 0 0 0-1.3-1.3z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgStopFilled);
export default Memo;
